import React, { useState } from "react"
import InputText from "component/inputText/inputText"
import IconsColor from "util/iconsColor"
import styles from "./configuration.module.scss"

type SecretFieldProps = {
    label: string
    value: string
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    placeholder?: string
    name?: string
    error?: string
    readOnly?: boolean
    showCopy?: boolean
    onCopy?: () => void
    hideLabel?: boolean
    autoComplete?: string
}

const SecretField: React.FC<SecretFieldProps> = ({
    label,
    value,
    onChange,
    placeholder,
    name,
    error,
    readOnly = false,
    showCopy = false,
    onCopy,
    hideLabel = false,
    autoComplete = "off",
}) => {
    const [visible, setVisible] = useState(false)

    return (
        <div className={styles.secretWrap}>
            <InputText
                label={label}
                hideLabel={hideLabel}
                value={value}
                onChange={onChange || (() => undefined)}
                placeholder={placeholder}
                type={visible ? "text" : "password"}
                name={name}
                autoComplete={autoComplete}
                error={error}
                disabled={readOnly}
                sx={{ paddingRight: showCopy ? "72px" : "44px" }}
            />
            <div className={styles.secretActions} style={hideLabel ? { top: 8 } : undefined}>
                <button
                    type="button"
                    className={styles.secretIconBtn}
                    onClick={() => setVisible((prev) => !prev)}
                    aria-label={visible ? "Hide password" : "Show password"}
                >
                    <IconsColor
                        iconName={visible ? "eyeOffIcon" : "eyeIcon"}
                        width="18"
                        height="18"
                        fillColor="none"
                        strokeColor="currentColor"
                    />
                </button>
                {showCopy && (
                    <button
                        type="button"
                        className={styles.secretIconBtn}
                        onClick={onCopy}
                        aria-label="Copy password"
                    >
                        <IconsColor iconName="copyIcon" width="18" height="18" fillColor="none" strokeColor="currentColor" />
                    </button>
                )}
            </div>
        </div>
    )
}

export default SecretField
